export default __webpack_public_path__ + "static/media/careteam_my_tickets_language.7e1492dd.svg";